// extracted by mini-css-extract-plugin
export var checkmark = "checkbox-module--checkmark--8KAWh";
export var input = "checkbox-module--input--8Q71q";
export var wrapper = "checkbox-module--wrapper--mLgT9";